var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11",
    "data-name": "Group 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 106.12,
    height: 47.66,
    viewBox: "0 0 106.12 47.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 106.12,
    height: 47.66,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M27.694,63.687H16.384c.712-13.348,29.5-23.5,17.674-37.368,4.879,12.7-25.515,23.77-19.276,37.368H3.077V39.071H16.872L20,35.994H0V66.764H30.771V46.5l-3.077,3.1Z",
    transform: "translate(0 -19.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M41.981,40.307C38.023,25.464,72.028,14.87,59.348,0c5.226,13.6-30.015,25.335-17.367,40.307",
    transform: "translate(-28.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M175.062,70.42h-8.236v-7.83h-2.759V78.818h2.759V70.947h8.236v7.871h2.759V62.589h-2.759Z",
    transform: "translate(-119.092 -45.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M227.631,62.59h-3.144l1.217,3.327-4.727,12.9h.588l1.42-3.875h6.045l1.4,3.875h3.327Zm-4.463,11.826,2.84-7.729,2.82,7.729Z",
    transform: "translate(-160.401 -45.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M287.438,78.818h2.84V62.589h-2.84l-4.929,11.989-4.95-11.989h-3.226V78.818h.629V63.279l6.451,15.539h.041l5.984-14.728Z",
    transform: "translate(-199.131 -45.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M348.689,78.818h3.327L345.89,62.59h-3.144l1.217,3.327-4.727,12.9h.588l1.42-3.875h6.045Zm-7.262-4.4,2.84-7.729,2.82,7.729Z",
    transform: "translate(-246.242 -45.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M166.249,146.737h3.535a2.751,2.751,0,0,1-2.955,2.723c-2.591,0-2.978-2.311-2.978-3.689,0-1.115.287-3.709,2.947-3.709a2.672,2.672,0,0,1,2.817,2.392l.03.21h.752l-.035-.275a3.37,3.37,0,0,0-3.565-3.079c-2.42,0-4.045,1.793-4.045,4.461,0,2.711,1.588,4.462,4.045,4.462,2.345,0,3.8-1.612,3.8-4.208v-.244h-4.35Z",
    transform: "translate(-118.138 -102.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M266.13,141.309c-2.43,0-4.126,1.834-4.126,4.461s1.7,4.462,4.126,4.462,4.126-1.835,4.126-4.462-1.7-4.461-4.126-4.461m0,.783c1.8,0,2.967,1.444,2.967,3.678s-1.165,3.679-2.967,3.679-2.967-1.444-2.967-3.679,1.165-3.678,2.967-3.678",
    transform: "translate(-190.181 -102.572)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M320.963,147.017c0,2.493-1.477,2.865-2.358,2.865-1.5,0-2.266-.992-2.266-2.947v-5.072h-1.058v5.021c0,2.489,1.07,3.75,3.181,3.75,2.08,0,3.273-1.293,3.273-3.547v-5.224h-.773Z",
    transform: "translate(-228.854 -102.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M369.3,141.864h-2.317v8.619h1.057v-3.456H369.4c1.97,0,3.1-.945,3.1-2.592s-1.167-2.572-3.2-2.572m-1.26.743h1.26c1.864,0,2.1.972,2.1,1.819,0,1.279-.617,1.849-2,1.849h-1.361Z",
    transform: "translate(-266.384 -102.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M221.771,150.016l-.012,0v-.007h-.019a1,1,0,0,1-.35-.193,2.7,2.7,0,0,1-.877-1.57l-.073-.236-.233.075.22-.112a4.081,4.081,0,0,0-.657-1.411l-.039-.048a1.474,1.474,0,0,0-.14-.158,2.263,2.263,0,0,0,1.475-2.121c0-1.572-1.067-2.368-3.171-2.368h-2.144v8.619h1.057v-3.862h1.3v0a2.21,2.21,0,0,1,.456.054.833.833,0,0,1,.276.207,2.578,2.578,0,0,1,.442.843c.071.193.132.394.194.6a4.606,4.606,0,0,0,.694,1.555,1.664,1.664,0,0,0,.895.581,1.59,1.59,0,0,0,.4.044l.1,0v0a1.06,1.06,0,0,0,.154,0l.033-.266.045-.007-.024-.164Zm-1.806-5.794c0,1.093-.622,1.646-1.849,1.646h-1.311v-3.262h1.209c1.313,0,1.951.529,1.951,1.615",
    transform: "translate(-156.605 -102.975)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bb10b0d15ef077c30b8c559a3cc33bb4.svg";
export { ForwardRef as ReactComponent };